import { render, staticRenderFns } from "./FrzDefectLoteRegistrationPanel.vue?vue&type=template&id=461e50ec&scoped=true"
import script from "./FrzDefectLoteRegistrationPanel.vue?vue&type=script&lang=js"
export * from "./FrzDefectLoteRegistrationPanel.vue?vue&type=script&lang=js"
import style0 from "./FrzDefectLoteRegistrationPanel.vue?vue&type=style&index=0&id=461e50ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461e50ec",
  null
  
)

export default component.exports